import { api } from "./api";

export type BannerSeverity = "info" | "warning" | "error" | "success";

/** A published banner as shown to end users. */
export type PublicBanner = {
  id: number;
  message: string;
  severity: BannerSeverity;
  updatedAt: string | null;
};

/** Background + readable text color per severity. */
export const SEVERITY_STYLES: Record<
  BannerSeverity,
  { bg: string; text: string; label: string }
> = {
  info: { bg: "#3b82f6", text: "#ffffff", label: "Info" },
  warning: { bg: "#f59e0b", text: "#1f2937", label: "Warning" },
  error: { bg: "#e74c3c", text: "#ffffff", label: "Error" },
  success: { bg: "#68ad18", text: "#ffffff", label: "Success" },
};

/** Public read used by the banner stack shown to every logged-in user. */
export const getPublishedBanners = (): Promise<PublicBanner[]> =>
  api
    .get<{ banners: PublicBanner[] }>("/api/v1/notification-banner")
    .then((r) => r.banners ?? []);
